module.exports = __webpack_public_path__ + "img/image-not-found-sk.2326ef0b.jpg";